<template lang="pug">
.rule.flex.column.p-40.gap-20
  i.el-icon-arrow-left.clickable(@click="goBack") 返回
  .content.flex.column
    .rule-title {{ title }}
    .content.white-space-pre
      template(v-for="(seg, idx) in segments")
        a.link-text(
          v-if="seg.href",
          :key="idx",
          :href="seg.href",
          target="_blank",
          rel="noopener noreferrer") {{ seg.text }}
        span(v-else, :key="idx") {{ seg.text }}
</template>

<script>
// 條款內文中的網址、Email、LINE 官方帳號轉成可點擊的連結
const LINK_PATTERN = /(https?:\/\/[^\s，。、）)]+|[\w.+-]+@[\w-]+(?:\.[\w-]+)+|@morphtw)/g;
const LINE_OFFICIAL_URL = 'https://lin.ee/u84WVJ2';

function toHref(text) {
  if (text === '@morphtw') {
    return LINE_OFFICIAL_URL;
  }
  if (/^https?:\/\//.test(text)) {
    return text;
  }
  return `mailto:${text}`;
}

export default {
  name: 'rule-view',
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
  computed: {
    segments() {
      const result = [];
      let last = 0;
      this.content.replace(LINK_PATTERN, (match, _p1, offset) => {
        if (offset > last) {
          result.push({ text: this.content.slice(last, offset) });
        }
        result.push({ text: match, href: toHref(match) });
        last = offset + match.length;
        return match;
      });
      if (last < this.content.length) {
        result.push({ text: this.content.slice(last) });
      }
      return result;
    },
  },
  methods: {
    goBack() {
      // 從其他頁以新分頁開啟時直接關閉分頁，回到原本的頁面
      if (window.opener && !window.opener.closed) {
        window.close();
        return;
      }
      // 直接貼網址開啟、沒有瀏覽紀錄時 $router.back() 沒有作用，改導回首頁
      if (window.history.length > 1) {
        this.$router.back();
        return;
      }
      this.$router.push('/home');
    },
  },
};
</script>

<style lang="scss" scoped>
.rule-title {
  font-size: 20px;
  color: #295294;
}
.link-text {
  color: #409EFF;
  word-break: break-all;
}
</style>
